import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import PropTypes from 'prop-types';
// 碎片组件
import Chip from 'Chip';
// 组件
import Nav from '../Nav';
import Content from '../Content';

const Activity = ({ content }) => {
    const { activity, activityTitle } = content;

    return (
        <div className={styles.wrap}>
            <Chip
                key="activityTitle"
                id="260157"
                name="activityTitle"
                type="struct"
                title="活动专区标题"
                groupName="活动专区标题"
                content={activityTitle}>
                <Nav />
            </Chip>

            <Chip
                key="activity"
                id="285747"
                name="activity"
                type="recommend"
                title="活动专区"
                groupName="活动专区"
                content={activity}>
                <Content />
            </Chip>
        </div>
    );
};

Activity.propTypes = {
    content: PropTypes.object,
};
export default errorBoundary(Activity);
